import { Injectable, inject } from "@angular/core";
import { ComponentView } from "src/modules/app-template/models/component-view.model";
import { SaveDataHandler } from "src/modules/app-template/models/save-data-handler.model";
import { MainAppService } from "src/modules/app-template/services/main-app.service";
import { RestEndpoint } from "src/modules/sm-base/models/rest-endpoint.model";
import { BrowserUploadedFile } from "src/modules/sm-base/models/uploaded-file.model";
import { FrontendFieldType } from "src/modules/sm-base/netgen/FrontendFieldType";
import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";
import { Strings } from "src/modules/utils/shared/strings";
import { EnaioDocumentWriteFrontendDefinition } from "../netgen/EnaioDocumentWriteFrontendDefinition";
import { EnaioDocumentWriteRequest } from "../netgen/EnaioDocumentWriteRequest";

@Injectable({
    providedIn: "root"
})
export class EnaioDocumentWriteService {

    private app = inject(MainAppService);

    async openDialog(definitionId: string, componentView?: ComponentView): Promise<boolean> {
        let definition = await RestEndpoint.main().query({id: definitionId}).run("api/doc/write").get(EnaioDocumentWriteFrontendDefinition);
        return this.openDialogInternal(definition, "api/doc/write", {}, componentView);
    }

    async openWorkflowDialog(definitionId: string, workItemId: string, componentView?: ComponentView): Promise<boolean> {
        let definition = await RestEndpoint.main().query({definitionId, workItemId}).run("api/wfl/workflow/workitem/document").get(EnaioDocumentWriteFrontendDefinition);
        return this.openDialogInternal(definition, "api/wfl/workflow/workitem/document", {workItemId}, componentView);
    }

    private async openDialogInternal(definition: EnaioDocumentWriteFrontendDefinition, endpoint: string, additionalRequestData: OrdinaryObject, componentView?: ComponentView): Promise<boolean> {
        if (await this.app.dialog.form(definition.form, definition.title || this.app.t("enaio.indexData")) != "ok") {
            return false;
        }

        let request = new EnaioDocumentWriteRequest();
        request.definitionId = definition.id;
        request.values = {};
        let fileField = definition.form.getAllFields().find(field => field.type == FrontendFieldType.fileUpload);
        for (let field of definition.form.getAllFields()) {
            if (field != fileField && field.visible && field.enabled && field.hasControl && ![FrontendFieldType.button, FrontendFieldType.buttonAsLink, FrontendFieldType.groupBox, FrontendFieldType.pageControl, FrontendFieldType.page, FrontendFieldType.splitter].includes(field.type)) {
                request.values[field.id] = field.getValue();
            }
        }
        if (fileField != null) {
            let files = fileField.value as BrowserUploadedFile[];
            if (files?.length > 0) {
                request.documentFileName = files[0].legacy.name;
                request.documentBase64 = Strings.bytesToBase64(files[0].contents);
            }
        }

        return (await this.app.saveDataHandler2(new SaveDataHandler({
            componentView,
            worker: async () => RestEndpoint.main().post().body(Object.assign(request, additionalRequestData)).run(endpoint).getText(),
            successText: "Das Dokument wurde erfolgreich erstellt."
        }))).ok;
    }
}
